import { JackpotTabEnum } from '@entities/jackpot';
import { useAppSelector } from '@app/store';

export function useJackpotHighlightedTabs() {
  const reservesJackpots = useAppSelector((s) => s.jackpot.reservesJackpots);
  const platinumNextDrawMs = useAppSelector((s) => s.jackpot.platinumNextDrawMs);
  const user = useAppSelector((s) => s.user.userData);

  const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

  const highlight: Record<JackpotTabEnum, boolean> = {
    [JackpotTabEnum.AllJackpots]: false,
    [JackpotTabEnum.TopPlayers]: false,
    [JackpotTabEnum.PartnersJackpot]: false,
    [JackpotTabEnum.PlatinumJackpot]: false,
    [JackpotTabEnum.MyJackpots]: false,
  };

  const activeReserve = reservesJackpots?.activePlayersJackpot;
  if (activeReserve?.reserves && activeReserve?.metadata?.drawAmount) {
    const ratio =
      Number(activeReserve.reserves) / Number(activeReserve.metadata.drawAmount);
    highlight[JackpotTabEnum.TopPlayers] = ratio >= 0.95;
  }

  const partnerReserve = reservesJackpots?.partnerJackpot;
  if (partnerReserve?.reserves && partnerReserve?.metadata?.drawAmount) {
    const ratio =
      Number(partnerReserve.reserves) / Number(partnerReserve.metadata.drawAmount);
    highlight[JackpotTabEnum.PartnersJackpot] = ratio >= 0.95;
  }

  if (platinumNextDrawMs !== undefined && platinumNextDrawMs < oneWeekMs) {
    highlight[JackpotTabEnum.PlatinumJackpot] = true;
  }

  const hasJackpotReward = !!user && Number(user.unreceivedJackpotWinnings) > 0;
  highlight[JackpotTabEnum.MyJackpots] = hasJackpotReward;

  return highlight;
}
